// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles spécifiques à TabDocuments
 * Complète MesDocuments.css pour la section Logo
 * FRONT-21: Styles pour les chapitres thématiques de documents
 */

/* =========================================
   FRONT-21: Chapitres de documents
   ========================================= */

/* Grand chapitre */
.document-chapter {
  margin-bottom: 3rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  overflow: hidden;
}

.chapter-header {
  background-color: #595959; /* Gris foncé - comme avant */
  color: #ffffff;
  padding: 1.25rem 1.5rem;
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0;
}

.chapter-description {
  padding: 0.75rem 1.5rem;
  font-size: 1.3rem;
  font-style: italic;
  color: #6b7280;
  background-color: #f9fafb;
}

.chapter-content {
  padding: 1.5rem;
  /* background-color: #ffffff; */
}

/* Sous-chapitre (section document) */
.document-section {
  margin-bottom: 1.5rem;
  border-radius: 0.375rem;
  overflow: hidden;
}

.section-header {
  background-color: #595959; /* Gris foncé avec bandeau */
  color: #ffffff;
  padding: 0.75rem 1rem;
  font-weight: 600;
  font-size: 1.4rem;
  margin: 0;
}

.section-note {
  background-color: #f3f4f6; /* Gris fond */
  color: #374151; /* Gris texte */
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
  font-style: italic;
  border-bottom: 1px solid #e5e7eb;
}

.section-content {
  padding: 1rem;
  background-color: #ffffff;
}

/* Messages informatifs en italique */
.info-message {
  display: block;
  font-size: 1.3rem;
  color: #6b7280;
  font-style: italic;
  padding: 0.75rem 0;
  text-align: right;
}

/* =========================================
   Section Logo entreprise
   ========================================= */

.logo-section-container {
  display: flex;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.logo-preview-box {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  border: 2px dashed #d7d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  overflow: hidden;
  flex-shrink: 0;
}

.logo-preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.logo-preview-text {
  color: #999;
  font-size: 1.2rem;
  text-align: center;
  padding: 0.5rem;
}

.logo-info-container {
  flex: 1 1;
  min-width: 200px;
}

.logo-info-text {
  margin: 0 0 0.5rem 0;
  font-size: 1.3rem;
  color: #666;
}

.logo-info-text:last-of-type {
  margin-bottom: 1rem;
}

.logo-error-text {
  margin: 0 0 1rem 0;
  font-size: 1.2rem;
  color: #dc2626;
  font-weight: 500;
}

.logo-buttons-container {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

/* =========================================
   Responsive
   ========================================= */

@media (max-width: 480px) {
  .logo-section-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .logo-preview-box {
    width: 80px;
    height: 80px;
  }

  .logo-info-container {
    width: 100%;
  }

  .logo-buttons-container {
    flex-direction: column;
    width: 100%;
  }

  .logo-buttons-container button {
    width: 100%;
  }
}

/* =========================================
   Astérisque obligatoire
   ========================================= */

.required-asterisk {
  color: #dc2626;
  font-weight: bold;
  margin-left: 0.25rem;
}

/* =========================================
   CORE-12: Message document non modifiable
   ========================================= */

.document-locked-message {
  display: block;
  font-size: 1.3rem;
  color: #6b7280;
  font-style: italic;
  padding: 0.75rem 0;
  text-align: right;
}

.subsection-header {
  font-size: 1.4rem;
}

.document-section > .section-content {
  border-radius: 10px;
}

.document-chapter > .chapter-header,
.document-chapter {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.document-section > .section-content > .documents-list {
  margin: 2rem 0 0 !important;
}

.document-section > .section-content > .documents-list > .documents-grid {
  margin: 0 !important;
}

.document-section > .section-content {
  gap: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/tabs/TabDocuments.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;;8CAE8C;;AAE9C,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;EACxD,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,cAAc,EAAE,eAAe;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;8CAE8C;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;8CAE8C;;AAE9C;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;8CAE8C;;AAE9C;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;8CAE8C;;AAE9C;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/**\n * Styles spécifiques à TabDocuments\n * Complète MesDocuments.css pour la section Logo\n * FRONT-21: Styles pour les chapitres thématiques de documents\n */\n\n/* =========================================\n   FRONT-21: Chapitres de documents\n   ========================================= */\n\n/* Grand chapitre */\n.document-chapter {\n  margin-bottom: 3rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  overflow: hidden;\n}\n\n.chapter-header {\n  background-color: #595959; /* Gris foncé - comme avant */\n  color: #ffffff;\n  padding: 1.25rem 1.5rem;\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.chapter-description {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.3rem;\n  font-style: italic;\n  color: #6b7280;\n  background-color: #f9fafb;\n}\n\n.chapter-content {\n  padding: 1.5rem;\n  /* background-color: #ffffff; */\n}\n\n/* Sous-chapitre (section document) */\n.document-section {\n  margin-bottom: 1.5rem;\n  border-radius: 0.375rem;\n  overflow: hidden;\n}\n\n.section-header {\n  background-color: #595959; /* Gris foncé avec bandeau */\n  color: #ffffff;\n  padding: 0.75rem 1rem;\n  font-weight: 600;\n  font-size: 1.4rem;\n  margin: 0;\n}\n\n.section-note {\n  background-color: #f3f4f6; /* Gris fond */\n  color: #374151; /* Gris texte */\n  padding: 0.5rem 1rem;\n  font-size: 1.2rem;\n  font-style: italic;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.section-content {\n  padding: 1rem;\n  background-color: #ffffff;\n}\n\n/* Messages informatifs en italique */\n.info-message {\n  display: block;\n  font-size: 1.3rem;\n  color: #6b7280;\n  font-style: italic;\n  padding: 0.75rem 0;\n  text-align: right;\n}\n\n/* =========================================\n   Section Logo entreprise\n   ========================================= */\n\n.logo-section-container {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  flex-wrap: wrap;\n}\n\n.logo-preview-box {\n  width: 100px;\n  height: 100px;\n  border-radius: 8px;\n  border: 2px dashed #d7d9d9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fafafa;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.logo-preview-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.logo-preview-text {\n  color: #999;\n  font-size: 1.2rem;\n  text-align: center;\n  padding: 0.5rem;\n}\n\n.logo-info-container {\n  flex: 1;\n  min-width: 200px;\n}\n\n.logo-info-text {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.3rem;\n  color: #666;\n}\n\n.logo-info-text:last-of-type {\n  margin-bottom: 1rem;\n}\n\n.logo-error-text {\n  margin: 0 0 1rem 0;\n  font-size: 1.2rem;\n  color: #dc2626;\n  font-weight: 500;\n}\n\n.logo-buttons-container {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n/* =========================================\n   Responsive\n   ========================================= */\n\n@media (max-width: 480px) {\n  .logo-section-container {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .logo-preview-box {\n    width: 80px;\n    height: 80px;\n  }\n\n  .logo-info-container {\n    width: 100%;\n  }\n\n  .logo-buttons-container {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .logo-buttons-container button {\n    width: 100%;\n  }\n}\n\n/* =========================================\n   Astérisque obligatoire\n   ========================================= */\n\n.required-asterisk {\n  color: #dc2626;\n  font-weight: bold;\n  margin-left: 0.25rem;\n}\n\n/* =========================================\n   CORE-12: Message document non modifiable\n   ========================================= */\n\n.document-locked-message {\n  display: block;\n  font-size: 1.3rem;\n  color: #6b7280;\n  font-style: italic;\n  padding: 0.75rem 0;\n  text-align: right;\n}\n\n.subsection-header {\n  font-size: 1.4rem;\n}\n\n.document-section > .section-content {\n  border-radius: 10px;\n}\n\n.document-chapter > .chapter-header,\n.document-chapter {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.document-section > .section-content > .documents-list {\n  margin: 2rem 0 0 !important;\n}\n\n.document-section > .section-content > .documents-list > .documents-grid {\n  margin: 0 !important;\n}\n\n.document-section > .section-content {\n  gap: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
